import {Routes} from "@angular/router";
import {CanMatchGuard} from "@overflo1/frame-frontend";
import {FamilyListComponent} from "./components/family-list/family-list.component";

const guards: any[] = [CanMatchGuard];

export const FamilyRoutes: Routes = [
  {
    path: 'frame/entity/family',
    component: FamilyListComponent,
    canMatch: guards
  },
];
